import { useEffect, useMemo } from 'react';
import { CancellationToken } from '@cian/http-api';

export const useCancellationEffect = () => {
  const cancellationToken = useMemo(() => new CancellationToken(), []);

  useEffect(() => {
    return () => {
      cancellationToken.cancel();
    };
  }, [cancellationToken]);

  return cancellationToken;
};
